import { Component, ElementRef, Host, HostBinding, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { isNotNil } from 'ng-zorro-antd/core/util';
import { QuestionSelectService } from '@workflow/queries/services/question-select.service';
import { delay } from 'rxjs/operators';

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: '[appSelectableQuestion]',
	templateUrl: './selectable-question.component.html',
	styleUrls: ['./selectable-question.component.scss'],
})
export class SelectableQuestionComponent implements OnDestroy {
	private readonly subscription = new Subscription();
	
	// eslint-disable-next-line @angular-eslint/no-input-rename
	@Input('appSelectableQuestion')
	public key?: string;
	
	@HostBinding('class.active')
	public active = false;
	
	@HostBinding('class.highlighted')
	public highlighted = false;
	
	constructor(
		private readonly questionSelectService: QuestionSelectService,
		@Host() elRef: ElementRef<HTMLElement>,
	) {
		this.subscription.add(
			questionSelectService.active$.subscribe(active => {
				this.active = active;
			}),
		);
		
		this.subscription.add(
			questionSelectService.highlight$.pipe(delay(1)).subscribe(keys => {
				this.highlighted = keys.includes(this.key);
				if (this.highlighted) {
					elRef.nativeElement.scrollIntoView({
						behavior: 'smooth',
						block: 'center',
						inline: 'center'
					});
				}
			}),
		);
	}
	
	public select(): void {
		if (this.active && isNotNil(this.key)) {
			this.questionSelectService.selected(this.key);
		}
	}
	
	public ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}
}
